module.exports = __webpack_public_path__ + "static/media/fly0131.d19398ca.webp";